import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MarketScanPage from './pages/MarketScanPage';
import ExtendedCryptoPage from './pages/ExtendedCryptoPage';
import IndividualSignalsPage from './pages/IndividualSignalsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import NotesPage from './pages/NotesPage';
import InstallPrompt from './components/InstallPrompt';
import './index.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('signals_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/login" 
          element={
            isAuthenticated ? 
            <Navigate to="/signals" /> : 
            <LoginPage setIsAuthenticated={setIsAuthenticated} />
          } 
        />
        <Route 
          path="/register" 
          element={
            isAuthenticated ? 
            <Navigate to="/signals" /> : 
            <RegisterPage />
          } 
        />
        <Route 
          path="/subscription" 
          element={
            isAuthenticated ? 
            <SubscriptionPage setIsAuthenticated={setIsAuthenticated} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/signals" 
          element={
            isAuthenticated ? 
            <MarketScanPage setIsAuthenticated={setIsAuthenticated} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/extended-crypto" 
          element={
            isAuthenticated ? 
            <ExtendedCryptoPage setIsAuthenticated={setIsAuthenticated} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/individual-signals" 
          element={
            isAuthenticated ? 
            <IndividualSignalsPage setIsAuthenticated={setIsAuthenticated} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/notes" 
          element={
            isAuthenticated ? 
            <NotesPage setIsAuthenticated={setIsAuthenticated} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route path="/" element={<Navigate to="/signals" />} />
      </Routes>
      <InstallPrompt />
    </BrowserRouter>
  );
}

export default App;
